import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findGrade= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-cluster/v1/grade/findAll?`+params,
        method: 'GET'
    })
}

export const addGrade = (data) => {
    return request({
        url: `${baseUrl}/joins-cluster/v1/grade/insertGrade`,
        method: 'POST',
        data: data
    })
}
export const editGrade = (data) => {
    return request({
        url: `${baseUrl}/joins-cluster/v1/grade/updateGrade`,
        method: 'PUT',
        data: data
    })
}
export const delGrade = (ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-cluster/v1/grade/deleteGrade/${temp}`,
        method: 'DELETE'
    })
}
export const find= () => {
    return request({
        url: `${baseUrl}/joins-cluster/v1/grade/find`,
        method: 'GET'
    })
}